import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider}from 'react-redux';
import configureStore from './store/configureStore';
import Amplify from 'aws-amplify';
import aws_exports from './aws-exports';

import 'semantic-ui-css/semantic.min.css'
Amplify.configure(aws_exports)

ReactDOM.render(
  <React.StrictMode>
    <Provider store ={configureStore}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
